import defaultReplication from '@/rxdb/defaultReplication';
import { preInsert, preRemove, preSave } from '@/rxdb/defaultHooks';

export const contacts = {
    schema: {
        title: 'contact schema',
        version: 3,
        description: 'describes a contact',
        primaryKey: 'id',
        type: 'object',
        properties: {
            id: {
                type: 'string',
                final: true,
                maxLength: 40,
            },
            companyId: {
                type: ['string', 'null'],
            },
            firstName: {
                type: ['string', 'null'],
            },
            lastName: {
                type: ['string', 'null'],
            },
            email: {
                type: ['string', 'null'],
            },
            phone: {
                type: ['string', 'null'],
            },
            role: {
                type: ['string', 'null'],
            },
            isReportRecipient: {
                type: ['boolean', 'null'],
            },
            createdBy: {
                type: ['string', 'null'],
                final: true,
            },
            updatedAt: {
                type: ['string', 'null'],
            },
            deletedAt: {
                type: ['string', 'null'],
            },
            deletedBy: {
                type: ['string', 'null'],
            },
            createdAt: {
                type: ['string', 'null'],
            },
            updatedBy: {
                type: ['string', 'null'],
            },
            projectId: {
                type: ['string', 'null'],
            },
            rootVersion: {
                type: ['string', 'null'],
            },
        },
    },
    options: {
        onCollectionCreated(projectId, rxCollection) {
            rxCollection.replicationState = defaultReplication(rxCollection, projectId);
            rxCollection.preRemove(preRemove, false);
            rxCollection.preInsert(preInsert, false);
            rxCollection.preSave(preSave, false);
        },
    },
    migrationStrategies: {
        1: (doc) => doc,
        2: (doc) => doc,
        3: (doc) => doc,
    },
};
